// extracted by mini-css-extract-plugin
module.exports = {"container":"CampaignCard__container___2mwO6","gradient":"CampaignCard__gradient___2__QX","label":"CampaignCard__label___ECd1H","disabled":"CampaignCard__disabled___2aPvV"};